import React, { Fragment, useEffect, useContext, useState } from "react";
import {
  Box,
  Card,
  CardContent,
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import { auth } from "../firebase";
import { AuthContext } from "../auth/AuthContext";
import { Link, useLocation, useNavigate } from "react-router-dom";
import useBackButtonRedirect from "../hooks/useBackButton";
import { UserDataContext } from "../context/UserDataContext";
import FirstTimeNotification from "../components/FirstTimeNotification";
import SectionHeader from "../components/SectionHeader";
import HomeTicketList from "../components/HomeTicketList";
import HomeCoupon from "../components/HomeCoupon";
import CampaignTabs from "../components/CampaignTabs";
import UserFreeTicket from "../components/UserFreeTicket";
import InterviewTicket from "../components/InterviewTicket";
import ThumbUpOutlinedIcon from "@material-ui/icons/ThumbUpOutlined";
import LoaderComponent from "../components/LoaderComponent";
import CalendarComponent from "../components/Calender";
import UsageFlow from "../components/Home/UsageFlow";
function Home() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const {
    getCouponData,
    interviewTicketData,
    supportTicketData,
    informationData,
    isTicketFree,
  } = useContext(UserDataContext);
  const { currentUser } = useContext(AuthContext);
  const [homeTicketList, setHomeTicketList] = useState<any | undefined>(
    undefined
  );
  const [hasNonRefundedTicket, setHasNonRefundedTicket] =
    useState<any>(undefined);
  const [idToken, setIdToken] = useState<string | undefined>("");
  const [welcomeBannerClass, setWelcomeBannerClass] = useState<boolean>(false);
  const useBackButton = state && state.hook == "usingBackButton";
  useBackButtonRedirect(useBackButton);
  useEffect(() => {
    if (interviewTicketData && supportTicketData) {
      setHomeTicketList([
        ...interviewTicketData.interviewtTicketList,
        ...supportTicketData.supportTicketList,
      ]);
    }
    console.log(interviewTicketData);
  }, [supportTicketData]);
  useEffect(() => {
    hasCampaignOrIsFirstTime();
  }, [informationData]);
  useEffect(() => {
    // currentUserが明示的にnullの場合はログイン画面へリダイレクト
    document.title = "ホーム | じぶん専用IT相談室";
    if (currentUser === undefined) {
      return;
    }
    if (currentUser === null) {
      navigate("/login", { state: { from: window.location.pathname } });
    }
    getIdToken();
  }, [currentUser]);
  useEffect(() => {
    if (homeTicketList && homeTicketList.length) {
      const data = homeTicketList.filter((ticket) => {
        if (
          ticket.unsolvedAfterFollowContent.length &&
          !["返金"].includes(ticket.unsolvedAfterFollowContent)
        ) {
          return;
        } else {
          return ticket.amountRefunded == undefined;
        }
      });
      setHasNonRefundedTicket(data);
    }
  }, [homeTicketList]);
  const getIdToken = async () => {
    const token = await auth.currentUser?.getIdToken();
    setIdToken(token);
  };
  function hasCampaignOrIsFirstTime() {
    var showClass = false;
    if (
      informationData &&
      (informationData.campaignList.length ||
        informationData.informationList.length)
    ) {
      showClass = true;
    }
    // if (firstUserData && firstUserData.isFirstTimeUser) {
    //   showClass = true;
    // }
    // if (
    //   interviewTicketData &&
    //   interviewTicketData.interviewtTicketList.length
    // ) {
    //   showClass = true;
    // }
    setWelcomeBannerClass(showClass);
  }
  return (
    <Fragment>
      {currentUser ? (
        <Box component={"section"}>
          <Box className={`welcome-banner`}>
            {informationData && <CampaignTabs data={informationData} />}
            {/* {firstUserData && firstUserData.isFirstTimeUser && (
              <FirstTimeNotification
                ticketList={firstUserData.userHasFreeTicket}
              />
            )} */}
            {/* {isTicketFree && <FirstTimeNotification />} */}
          </Box>
          {/* {firstUserData && firstUserData.isFirstTimeUser == false ? (
            <UsageFlow isFirstTimeUser={true} />
          ) : (
            ""
          )} */}
          <UsageFlow isFirstTimeUser={true} />
          <Box className="home-tickets bg-dots light-dots">
            <Container className="container">
              <SectionHeader
                currentPage={"保有チケット"}
                preHeading={"Ticket"}
              />

              {homeTicketList ? (
                <Fragment>
                  {homeTicketList.length &&
                  hasNonRefundedTicket &&
                  hasNonRefundedTicket.length ? (
                    <HomeTicketList ticketList={homeTicketList} />
                  ) : (
                    <Typography className="text-center no-data-text">
                      <span>チケットはありません</span>
                    </Typography>
                  )}
                </Fragment>
              ) : (
                <LoaderComponent />
              )}
            </Container>
          </Box>
          {/* {firstUserData && firstUserData.isFirstTimeUser ? (
            <UsageFlow isFirstTimeUser={true} />
          ) : (
            ""
          )} */}
          <Box className="home-ticket-selection bg-dots">
            <Container className="container">
              <SectionHeader
                currentPage={"チケット購入"}
                preHeading={"Menu Select"}
              />
              {interviewTicketData ? (
                <Grid container spacing={2}>
                  {/* {firstUserData && firstUserData.isFirstTimeUser ? (
                    <UserFreeTicket
                      ticketList={firstUserData.userHasFreeTicket}
                      showButton={false}
                    />
                  ) : (
                    <InterviewTicket />
                  )} */}
                  {isTicketFree ? <UserFreeTicket /> : <InterviewTicket />}
                  <Grid item md={6} xs={12} sm={12}>
                    <Card className="card-wrapper">
                      <CardContent style={{ padding: "0" }}>
                        <Box className="card-top-section">
                          <Box className="card-icon-top">
                            <img src={"/images/reason03_circle.png"} />
                          </Box>
                          <Typography
                            variant="h4"
                            component="h4"
                            className="classification-heading font-cur"
                          >
                            解決サポートを希望する
                          </Typography>
                        </Box>
                        <Box className="card-section-bottom">
                          <Typography component={"h6"} className="sub-title">
                            お困りごとが明確で、サポートチケットをご購入の方はこちら。
                          </Typography>
                          <Typography
                            style={{
                              marginBottom: "50px",
                            }}
                          >
                            専門知識を持つ相談員がお客様のお困りごとを解決いたします。
                          </Typography>
                          <Link to="/support/menu" style={{ color: "#fff" }}>
                            <button className="classification-btn full-width">
                              チケット購入ページへ
                            </button>
                          </Link>
                          <Typography
                            className="text-center"
                            style={{
                              marginTop: "1rem",
                              color: "var(--dark-grey)",
                            }}
                          >
                            ※チケット選択画面に進みます
                          </Typography>
                        </Box>
                      </CardContent>
                    </Card>
                  </Grid>
                </Grid>
              ) : (
                <LoaderComponent />
              )}
            </Container>
          </Box>
          <CalendarComponent />
          {getCouponData && getCouponData.couponList.length ? (
            <Fragment>
              <Box className="home-coupon">
                <Container className="container">
                  <SectionHeader
                    currentPage={"クーポン"}
                    preHeading={"Coupon"}
                  />
                  {getCouponData ? (
                    <Fragment>
                      {getCouponData.couponList.length ? (
                        <HomeCoupon coupons={getCouponData.couponList} />
                      ) : (
                        <Typography className="text-center no-data-text">
                          <span>クーポンはありません</span>
                        </Typography>
                      )}
                    </Fragment>
                  ) : (
                    <LoaderComponent />
                  )}
                </Container>
              </Box>
              <Box className="coupon-guide section">
                <Container className="container">
                  <Typography className="coupon-guide-header" component="h3">
                    <img src={"/images/reason04_icon.png"} alt="coupon icon" />
                    <span>クーポンご利用の流れ</span>
                  </Typography>
                  <Grid container alignItems="center">
                    <Grid item xs>
                      <p className="step">
                        STEP <span>01</span>
                      </p>
                    </Grid>
                    <Grid item xs>
                      <p className="step">
                        STEP <span>02</span>
                      </p>
                    </Grid>
                  </Grid>
                  <Grid container className="coupon-guide-side">
                    <Grid item xs>
                      <Typography component={"h4"}>お支払い画面</Typography>
                      <Typography>
                        利用可能なクーポンが表示されますので、選択してください。
                      </Typography>
                    </Grid>
                    <Grid item xs>
                      <Typography component={"h4"}>クーポン適用</Typography>
                      <Typography>
                        クーポンを選択すると、クーポンが適用され、割引された金額が表示されます。
                      </Typography>
                    </Grid>
                  </Grid>
                </Container>
              </Box>
            </Fragment>
          ) : (
            ""
          )}
        </Box>
      ) : (
        <LoaderComponent />
      )}
    </Fragment>
  );
}

export default Home;
